import { Component, input } from '@angular/core';
import { SharedModule } from '@app/modules/shared.module';
import { HygieneChange } from '@app/models/carnet-liaison';
import { CarnetHeureFormatPipe } from '../../carnet-liaison.pipe';

@Component({
  selector: 'app-carnet-hygiene',
  templateUrl: './carnet-hygiene.component.html',
  styleUrl: './carnet-hygiene.component.scss',
  standalone: true,
  imports: [SharedModule, CarnetHeureFormatPipe],
})
export class CarnetHygieneComponent {
  data = input.required<HygieneChange>();
}
